import Vue from "vue";
import VPasswordField from "@/vuetify-extensions/VPasswordField.vue";

Vue.component("v-password-field", VPasswordField);
